import styles from './TitleContainer.module.css';

function TitleContainer({
  assetName,
  assetType,
  assetLocation,
}) {

  return (
    <div className={styles.titleContainer}>
      <h2>
        {assetName}
      </h2>
      <h3>
        {assetType}
      </h3>
      <h3>
        {assetLocation}
      </h3>
    </div>
  )
}

export default TitleContainer;